// Force port redirection before any other imports
import './services/apiUrlFixer';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/accessibility.css';
import './design-system/tokens.css'; // WIG design tokens (CSS custom properties)
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop warnings (harmless Material-UI warnings)
const resizeObserverError = (e: ErrorEvent) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', resizeObserverError);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
